<template>
  <WsVersion
    label="法條版本列表"
    :localeMode="true"
    :id="$route.params.id"
    :modelName="modelName"
    :versionModelName="versionModelName"
    :fields="versionFields"
    :showFields="showFields"
    titleKey="last_version.no_text"
    :versionTimestampKey="versionTimestampKey"
    :editable="editable && !_isIdtfIdentifying"
    :customBreads="_customBreads"
    :hasCatchVersion="hasCatchVersion"
    :deletable="false"
    @getVersionData="$_getVersionDataList($event)"
  />
</template>

<script>
import parentmodel from "@/models/act";
import model from "@/models/article";
export default {
  data: () => ({
    modelName: model.modelName,
    parentModelName: parentmodel.modelName,
    versionModelName: model.versionModelName,
    parentVersionName: parentmodel.versionModelName,
    parentLabel: parentmodel.label,
    versionFields: model.fields.last_version.fields,
    versionTimestampKey: model.versionTimestampKey,
    editable: true,
    versionDataList: null,
    parentModelData: null,
    hasCatchVersion: true,
    showFields: [
      "locales",
      "no_number",
      "announce_at",
      "effect_at",
      "attaches",
      "reference_link",
      "effects",
    ],
  }),
  computed: {
    _customBreads() {
      const breadArr = [{
        text: this.parentLabel,
        to: `/${this.parentModelName}`,
        disabled: false,
      }];
      if (this.parentModelData) {
        breadArr.push({
          text: this.parentModelData.name,
          to: `/${this.parentModelName}/${this.parentModelData.id}`,
          disabled: false,
        });
      } else {
        breadArr.push({
          text: this.parentLabel,
          to: `/${this.parentModelName}`,
          disabled: false,
        });
      }
      breadArr.push({
        text: `版本列表`,
        disabled: true,
      });
      return breadArr;
    },
    _idtfStatus() {
      if (!this.parentModelData) return '';
      return this.parentModelData.last_version.act_idtf_status;
    },
    _isIdtfIdentifying() {
      if (!this.parentModelData) return true;
      return this._idtfStatus === 'identifying';
    },
  },
  methods: {
    async $_getVersionDataList($event) {
      this.versionDataList = $event.versionData;
      await this.$_getParentModelData();
    },
    async $_getParentModelData() {
      if (!this.versionDataList || !this.versionDataList.length) return;
      const selectingLocale = this.$store.state.locale.selectingLocale;
      const parentId = this.versionDataList[0][this.modelName][this.parentVersionName][this.parentModelName].id;
      try {
        const parentRes = await this.$axios.get(
          `${this.parentModelName}/${parentId}?locale=${selectingLocale}`
        );
        this.parentModelData = parentRes.data.data;
      } catch (err) {
        alert(err);
      }
    },
  },
};
</script>